import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Industries from "@/pages/Industries";
import Contact from "@/pages/Contact";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import FAQ from "@/pages/FAQ";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { Toaster } from "sonner";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  React.useEffect(() => {
    if (hash) {
      // wait one paint so the target section is in the DOM before scrolling
      const id = hash.replace(/^#/, "");
      requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    } else {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [pathname, hash]);
  return null;
}

function Public({ children }) {
  return <Layout>{children}</Layout>;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Public><Home /></Public>} />
          <Route path="/services" element={<Public><Services /></Public>} />
          <Route path="/industries" element={<Public><Industries /></Public>} />
          <Route path="/contact" element={<Public><Contact /></Public>} />
          <Route path="/blog" element={<Public><Blog /></Public>} />
          <Route path="/blog/:slug" element={<Public><BlogDetail /></Public>} />
          <Route path="/faq" element={<Public><FAQ /></Public>} />
          <Route path="/admin/login" element={<><AdminLogin /><Toaster theme="dark" position="top-right" richColors /></>} />
          <Route path="/admin" element={<><AdminDashboard /><Toaster theme="dark" position="top-right" richColors /></>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
